<template lang="pug">
  .section
    table(class="w-[300px]")
      tr
        td
          p(class="p max b required") 앨범명(국내)
        td
          string-item(:editMode="editMode"
            input-class="deco"
            :value="album.name"
            :error="error.name"
            @change="val => changeAlbumField(['name', val])")
          p.p.error {{error.name}}
      tr
        td
          p(class="p max b required") 앨범명(해외)
        td
          string-item(:editMode="editMode"
            input-class="deco"
            :value="album.nameEn"
            :error="error.nameEn"
            @change="val => changeAlbumField(['nameEn', val])")
          p.p.error {{error.nameEn}}
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import StringItem from "@/components/ui/StringItem.vue";


export default {
  name: "AlbumDetailPartial",
  components: {StringItem},
  props: {
    editMode: Boolean,
  },
  computed: {
    ...mapGetters("album", {
      album: "album",
      error: "error",
    }),
  },
  methods: {
    ...mapMutations("album", {
      changeAlbumField: "changeAlbumField",
    }),
    ...mapActions("album", {
      getDetailAlbum: "getDetailAlbum"
    }),
  },
};
</script>